import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import { useNavigate } from "react-router-dom";

import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import { IconButton } from "@mui/material";

import SpinLoader from "components/SpinLoader";
import CloseIcon from "@mui/icons-material/Close";

import { getShowBlockedUsers } from "services/apiService";
import { unBlockUser } from "services/apiService";
import { blockUser } from "services/apiService";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";

function ShowBlockedUsers({ openStatus, onClose }) {
  let navigate = useNavigate();
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [tempList, setTempList] = useState([]);
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchBlockedUsers();
  }, []);

  const fetchBlockedUsers = async () => {
    setLoading(true);
    const getShowBlockedUsersRes = await getShowBlockedUsers();
    // console.log("getShowBlockedUsersRes", getShowBlockedUsersRes);
    if (getShowBlockedUsersRes.status === 200) {
      setBlockedUsers(getShowBlockedUsersRes.data);
      setLoading(false);
    }
    setLoading(false);
  };

  const handleBlockUnBlock = async (status, username) => {
    setBtnLoader(true);
    if (status === "unBlock") {
      const unBlockUserRes = await unBlockUser(username);
      //   console.log("unBlockUserRes", unBlockUserRes);
      if (unBlockUserRes.status === 200) {
        toast.success(
          `User successfully unblocked, Follow to see thier posts`,
          {
            style: {
              fontSize: "15px",
            },
          }
        );
      }
      setTempList([...tempList, username]);
      setBtnLoader(false);
    } else {
      const blockUserRes = await blockUser(username);
      //   console.log("blockUserRes", blockUserRes);
      if (blockUserRes.status === 200) {
        toast.success(
          `User successfully block, You wont see thier post until you unblock them`,
          {
            style: {
              fontSize: "15px",
            },
          }
        );
      }
      setTempList(tempList.filter((name) => name !== username));
      setBtnLoader(false);
    }
  };

  return (
    <Dialog
      sx={{}}
      open={openStatus}
      maxWidth="sm"
      fullWidth
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        id="scrollableBox"
        sx={{
          height: isTabletOrMobile && "1000px",
          overflow: "auto",
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // objectFit: "cover",
          // backgroundPosition: isTabletOrMobile && "bottom",
        }}
      >
        <DialogTitle sx={{ marginBottom: "1rem" }}>
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <MDBox>
              <MDTypography
                fontWeight="bold"
                color="singh"
                sx={{
                  textAlign: "center",
                  fontSize: isTabletOrMobile ? "15px" : "30px",
                  marginRight: isTabletOrMobile && "120px",
                  marginTop: isTabletOrMobile && "15px",
                }}
              >
                Blocked Users
              </MDTypography>
            </MDBox>

            <IconButton onClick={onClose} color="white" fontSize="30px">
              <CloseIcon />
            </IconButton>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <MDBox sx={{ marginTop: "3rem", textAlign: "center" }}>
              <SpinLoader />
            </MDBox>
          ) : blockedUsers.length > 0 ? (
            blockedUsers.map((item, idx) => (
              <MDBox
                key={idx}
                style={{
                  marginBottom: "20px",
                  display: "flex",
                  // gap: "10px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <MDBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                  // onClick={() => handleNavigate(item.username)}
                >
                  <MDAvatar
                    src={item.pic}
                    imgProps={{
                      style: { height: "100%", width: "100%" },
                    }}
                  />
                  <MDBox>
                    <MDTypography fontWeight="bold">
                      {item.fullName}
                    </MDTypography>
                    <MDTypography fontSize="15px">{item.username}</MDTypography>
                  </MDBox>
                </MDBox>

                <MDBox>
                  {tempList.includes(item.username) ? (
                    <MDButton
                      color="singh"
                      onClick={() => handleBlockUnBlock("block", item.username)}
                      sx={{ minWidth: "120px" }}
                    >
                      {/* {btnLoader ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : ( */}
                      Block
                      {/* )} */}
                    </MDButton>
                  ) : (
                    <MDButton
                      color="singh"
                      onClick={() =>
                        handleBlockUnBlock("unBlock", item.username)
                      }
                      sx={{ minWidth: "120px" }}
                    >
                      UnBlock
                    </MDButton>
                  )}
                </MDBox>
              </MDBox>
            ))
          ) : (
            <MDBox sx={{ textAlign: "center", marginTop: "3rem" }}>
              <MDTypography color="text">
                You have not blocked anyone yet
              </MDTypography>
            </MDBox>
          )}
        </DialogContent>
      </MDBox>
    </Dialog>
  );
}

export default ShowBlockedUsers;
